<template>
    <router-view />
</template>

<script>


export default{
    name: "CatalogsViewsContainer"
}
</script>
